import { render, staticRenderFns } from "./TableThumb.vue?vue&type=template&id=6b5770ef&scoped=true"
import script from "./TableThumb.vue?vue&type=script&lang=js"
export * from "./TableThumb.vue?vue&type=script&lang=js"
import style0 from "./TableThumb.vue?vue&type=style&index=0&id=6b5770ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5770ef",
  null
  
)

export default component.exports